'use client';

import { httpMethods } from '@/constants/http-methods';
import { UpdateFavoriteTheater } from '@/types/favorite-theater';
import { PagedRequest } from '@/types/paged-requests/paged-request';
import { commonFetch, CommonFetchResponse } from '@/utils/common-fetch';
import { buildUrlWithParams } from '@/utils/url-params';
import { PagedListOfProfileTheater, ProfileTheater } from '@cinemark/profile-api-client';

class FavoriteTheatersApiService {
  private readonly favoriteTheatersUrl = '/papi/profiles/me/favorite-theaters';

  async getFavoriteTheaters(request: PagedRequest): Promise<CommonFetchResponse<PagedListOfProfileTheater>> {
    const response = await commonFetch<PagedListOfProfileTheater>(buildUrlWithParams(this.favoriteTheatersUrl, request as unknown as Record<string, unknown>));
    return response;
  }

  async addFavoriteTheater(favoriteTheaterData: UpdateFavoriteTheater): Promise<ProfileTheater> {
    const response = await commonFetch<ProfileTheater>(this.favoriteTheatersUrl, {
      body: JSON.stringify(favoriteTheaterData),
      method: httpMethods.post,
    });

    return response.data;
  }

  async updateFavoriteTheater(profileTheater: UpdateFavoriteTheater): Promise<CommonFetchResponse<ProfileTheater>>{
    const response = await commonFetch<ProfileTheater>(`${this.favoriteTheatersUrl}/${profileTheater.customerTheaterXrefId}`, {
      body: JSON.stringify(profileTheater),
      method: httpMethods.put,
    });

    return response;
  }

  async removeFavoriteTheater(profileTheater: UpdateFavoriteTheater): Promise<void> {
    await commonFetch(`${this.favoriteTheatersUrl}/${profileTheater.customerTheaterXrefId}`, {
      body: JSON.stringify(profileTheater),
      method: httpMethods.delete,
    });
  }
}

export const favoriteTheatersApiService = new FavoriteTheatersApiService();
